// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"0943d754","583":"e72bab9d"}[chunkId] + ".chunk.css";
};